import {
  createAdditionalPaymentResponse200,
  getDraftAdditionalPaymentResponse200BRL,
  getFailedAdditionalPaymentResponse200BRL,
} from "./get-additional-payment-200.js";
import type {
  Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success,
  Trips_ProcessAdditionalPayment_ProcessAdditionalPaymentCommandResponse_PaymentAuthRequired,
  Trips_ProcessAdditionalPayment_ProcessAdditionalPaymentCommandResponse_Success,
} from "../../swagger-types/v1/index.js";
import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";

type AdditionalPaymentGet200Overrides = {
  status: Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success["status"];
  amount?: Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success["amount"]["amount"];
  currencyCode?: Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success["amount"]["currencyCode"];
  isTaxIdRequired?: Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success["paymentProvider"]["isTaxIdRequired"];
};

const createGetAdditionalPayment200Handler = ({
  status,
  amount,
  currencyCode,
  isTaxIdRequired,
}: AdditionalPaymentGet200Overrides) => [
  http.get(`**${apiPaths.additionalPayment.get}`, () => {
    return HttpResponse.json(
      createAdditionalPaymentResponse200({
        status,
        amount,
        currencyCode,
        isTaxIdRequired,
      }),
      { status: 200 },
    );
  }),
];

const draftAdditionalPaymentResponse200 = createAdditionalPaymentResponse200({ status: "Draft" });

const getDraftAdditionalPaymentMalformedStripeMetadata200Response: Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success =
  {
    ...draftAdditionalPaymentResponse200,
    paymentProvider: {
      ...draftAdditionalPaymentResponse200.paymentProvider,
      providerMetadata: "not-json",
    },
  };

const getDraftAdditionalPaymentMalformedStripeMetadata200Handler = [
  http.get(`**${apiPaths.additionalPayment.get}`, () => {
    return HttpResponse.json(getDraftAdditionalPaymentMalformedStripeMetadata200Response, { status: 200 });
  }),
];

const getDraftAdditionalPayment200Handler = createGetAdditionalPayment200Handler({ status: "Draft" });
const getCompletedAdditionalPayment200Handler = createGetAdditionalPayment200Handler({ status: "Completed" });
const getFailedAdditionalPayment200Handler = createGetAdditionalPayment200Handler({ status: "Failed" });
const getInProcessAdditionalPayment200Handler = createGetAdditionalPayment200Handler({ status: "InProcess" });

const getDraftAdditionalPaymentBrl200Handler = [
  http.get(`**${apiPaths.additionalPayment.get}`, () => {
    return HttpResponse.json(getDraftAdditionalPaymentResponse200BRL, { status: 200 });
  }),
];

const getFailedAdditionalPaymentBrl200Handler = [
  http.get(`**${apiPaths.additionalPayment.get}`, () => {
    return HttpResponse.json(getFailedAdditionalPaymentResponse200BRL, { status: 200 });
  }),
];

const postAdditionalPayment200Response: Trips_ProcessAdditionalPayment_ProcessAdditionalPaymentCommandResponse_Success =
  { status: "Completed" };

const postAdditionalPayment200Handler = [
  http.post(`**${apiPaths.additionalPayment.post}`, () => {
    return HttpResponse.json(postAdditionalPayment200Response, { status: 200 });
  }),
];

const createPostAdditionalPayment200WithRedirectHandler = (redirectUrl: string) => [
  http.post(`**${apiPaths.additionalPayment.post}`, () => {
    const response: Trips_ProcessAdditionalPayment_ProcessAdditionalPaymentCommandResponse_PaymentAuthRequired = {
      redirectUrl,
      status: "ProcessingAtPaymentProvider",
    };
    return HttpResponse.json(response, { status: 200 });
  }),
];

export const additionalPaymentHandlers = {
  get200Draft: getDraftAdditionalPayment200Handler,
  get200DraftMalformedStripeMetadata: getDraftAdditionalPaymentMalformedStripeMetadata200Handler,
  get200Completed: getCompletedAdditionalPayment200Handler,
  get200Failed: getFailedAdditionalPayment200Handler,
  get200InProcess: getInProcessAdditionalPayment200Handler,
  get200DraftBrlCurrency: getDraftAdditionalPaymentBrl200Handler,
  get200FailedBrlCurrency: getFailedAdditionalPaymentBrl200Handler,
  post200: postAdditionalPayment200Handler,
} as const;

export const additionalPaymentHandlersFactory = {
  createGet200: (overrides: AdditionalPaymentGet200Overrides) => createGetAdditionalPayment200Handler(overrides),
  createPost200WithRedirect: (redirectUrl: string) => createPostAdditionalPayment200WithRedirectHandler(redirectUrl),
} as const;
